// extracted by mini-css-extract-plugin
export default {"title":"SeatingPlanScreen_title__WOWYm","mainDiv":"SeatingPlanScreen_mainDiv__QK-GC"};